import React from 'react';
import { ListChecks, UserRound, Files, ClipboardCheck } from 'lucide-react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

const sections = [
  ['activity', 'Activity', 'Activity', ListChecks],
  ['details', 'Details', 'Details', UserRound],
  ['documents', 'Documents', 'Docs', Files],
  ['registration', 'Registration', 'Register', ClipboardCheck],
];
export const ProfileTabs = () => <TabsList className="profile-tab-strip w-full h-auto grid grid-cols-4 gap-1 p-1" data-testid="profile-tabs">
  {sections.map(([key, label, shortLabel, Icon]) => <TabsTrigger key={key} value={key} className="min-h-[44px] min-w-0 text-sm" data-testid={`${key}-tab`} aria-label={label} title={label}>
    <Icon className="sm:hidden w-4 h-4" aria-hidden="true" /><span className="sm:hidden">{shortLabel}</span><span className="hidden sm:inline">{label}</span>
  </TabsTrigger>)}
</TabsList>;